import { render, staticRenderFns } from "./Extension.vue?vue&type=template&id=4299c59b&"
import script from "./Extension.vue?vue&type=script&lang=js&"
export * from "./Extension.vue?vue&type=script&lang=js&"
import style0 from "./Extension.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4299c59b')) {
      api.createRecord('4299c59b', component.options)
    } else {
      api.reload('4299c59b', component.options)
    }
    module.hot.accept("./Extension.vue?vue&type=template&id=4299c59b&", function () {
      api.rerender('4299c59b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/GuideChildren/Extension.vue"
export default component.exports